import axios from 'axios';

export function getSessionInfo(applicationId, to) {
  const parameters = [
    applicationId ? `applicationId=${encodeURIComponent(applicationId)}` : '',
    to ? `to=${encodeURIComponent(to)}` : '',
  ]
    .filter(Boolean)
    .join('&');
  return axios.get(`api/session?${parameters}`).then((response) => response.data);
}

export function logoutSession() {
  return axios.delete('api/session');
}
